export default __webpack_public_path__ + "static/media/IMG_2924.087fc184.jpeg";